module.exports = __webpack_public_path__ + "img/Ella.0a97202c.jpg";